<div>
    
    <div class="container">
        <div class="header">

        </div>
        <div class="body-container table-responsive">
            <button class="btn btn-success my-1" (click)="newData()">Nuevo</button>
            <table class="table mx-auto">
                <thead class="thead-dark bg-blue">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Fecha de Salida</th>
                    <th scope="col">Lugar de Salida</th>
                    <th scope="col">Remitente</th>
                    <th scope="col">Fecha de llegada</th>
                    <th scope="col">Lugar de llegada</th>
                    <th scope="col">Destinatario</th>
                    <th scope="col">Estado</th>
                    <th scope="col" colspan="2">Acciones</th>
                  </tr>
                </thead>
                <tbody *ngIf="(listTrack | async) as lT">
                  <tr *ngFor="let track of lT | paginate: { id: 'track', itemsPerPage: 10, currentPage: p }">
                    <td>{{track.id}}</td>
                    <td>{{track.dateStart}}</td>
                    <td>{{track.cityStart}}</td>
                    <td>{{track.nameStart}}</td>
                    <td>{{track.dateEnd}}</td>
                    <td>{{track.cityEnd}}</td>
                    <td>{{track.nameEnd}}</td>
                    <td>{{getStatus(track.status)}}</td>
                    <td colspan="2" >
                      <span class="btn btn-sm btn-primary mx-1" (click)="editData(track)"><i class="far fa-edit"></i> Editar</span>
                      <span class="btn btn-sm btn-success mx-1" (click)="showImage(track.id)"><i class="fas fa-file-image"></i> Ver Imágenes</span>
                      <span class="btn btn-sm btn-danger mx-1" (click)="deleteTrack(track.id)"><i class="fas fa-trash-alt"></i> Delete</span>
                    </td>
                  </tr>
                </tbody>  
            </table>
            <div class="mt-2" align="center" style="width:100%">
              <pagination-controls (pageChange)="p = $event" previousLabel="anterior" nextLabel="siguiente" id="track"></pagination-controls>
            </div>
        </div>

    </div>
</div>


<ng-template  tabindex="-1" role="dialog" id="modalNew" #ModalNew>
  <div class="modal-header">
    <h5 class="modal-title" id="titleDeleteSocial">{{titleModal}}</h5>
    <button class="close" type="button" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
      <form method="POST" enctype="application / x-www-form-urlencoded"  #fRecommend="ngForm" [formGroup]="sendForm" (submit)="onEditSubmit()">
          <div class="form-group" >
            <label for="idData">ID</label>
           <input type="text" id="idData" formControlName="idData" name="idData" class="form-control">
         </div>
         <div class="form-group" >
          <label for="fromStart">Lugar de Salida</label>
         <input type="text" name="cityStart" id="fromStart" formControlName="cityStart" class="form-control">
       </div>
        <div class="form-group" >
            <label for="nameStart">Nombre del Remitente</label>
           <input type="text" name="nameStart" id="nameStart"  formControlName="nameStart" class="form-control">
         </div>
          <div class="form-group" >
            <label for="dateStart">Fecha de Salida</label>
           <input type="datetime" name="dateStart" id="dateStart" formControlName="dateStart" class="form-control">
         </div>
          <div class="form-group" >
            <label for="cityEnd">Lugar de Llegada</label>
           <input type="text" name="cityEnd" id="cityEnd" formControlName="cityEnd" class="form-control">
         </div>
          <div class="form-group" >
            <label for="nameEnd">Nombre del Destinatario</label>
           <input type="text" name="nameEnd" id="nameEnd" formControlName="nameEnd" class="form-control">
         </div>
          <div class="form-group" >
            <label for="dateEnd">Fecha de Llegada</label>
           <input type="datetime" name="dateEnd" id="dateEnd" formControlName="dateEnd" class="form-control">
         </div>
         <div class="form-group" >
          <label for="status">Estado</label>
          <select formControlName="status" id="status" class="form-control">
            <option *ngFor="let s of status; let i = index" [value]="status[i].id">
              {{status[i].name}}
            </option>
          </select>
        
        </div>
         <div class="form-group">
          <label for="description">Descripción</label>
          <textarea name="description" id="description" class="form-control" formControlName="description"></textarea>
       </div>

       <div class="row">
         <button class="btn btn-md col-4 btn-secondary ml-auto mr-1" type="reset" (click)="closeModal()">Cancelar</button>
         <button class="btn btn-md col-4 btn-success mr-auto ml-1" type="submit">Aplicar</button>
       </div>
     </form>
  </div>
</ng-template>